import { RECEIVED_MARKETS } from '../actions/GetMarkets';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIVED_MARKETS:
      return action.markets;
    default:
      return state;
  }
};
